<template>
  <el-dialog
    v-model="visible"
    :title="dialogConfig.type ? '新建' : '编辑'"
    width="60%"
    :close-on-click-modal="false"
  >
    <el-form
      :model="formData"
      :rules="rules"
      ref="ruleRef"
      label-width="120"
      v-loading="loading"
    >
      <el-row :gutter="10">
        <el-col :span="8"
          ><el-form-item label="物料名称：" prop="name">
            <el-input
              v-model="formData.name"
              v-no-space
              placeholder="请输入名称"
              :maxlength="20"
            /> </el-form-item
        ></el-col>
        <el-col :span="8"
          ><el-form-item label="物料编号：" prop="number">
            <el-input
              v-model="formData.number"
              v-no-space
              placeholder="请输入编号"
              :maxlength="40"
            /> </el-form-item
        ></el-col>
        <el-col :span="8">
          <el-form-item label="物料类别：" prop="categoryId">
            <el-tree-select
              v-model="formData.categoryId"
              :data="dialogConfig.tree"
              :render-after-expand="false"
              show-checkbox
              :props="defaultProps"
              :check-strictly="true"
              node-key="id"
              style="width: 100%"
            /> </el-form-item
        ></el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8"
          ><el-form-item label="品牌：" prop="brand">
            <el-select v-model="formData.brand" style="width: 100%">
              <el-option
                v-for="item in brandList"
                :key="item.dictValue"
                :label="item.dictLabel"
                :value="item.dictValue"
              />
            </el-select> </el-form-item
        ></el-col>
        <el-col :span="8"
          ><el-form-item label="规格型号：" prop="model">
            <!-- <el-select v-model="formData.model" style="width: 100%">
              <el-option
                v-for="item in modelList"
                :key="item.dictValue"
                :label="item.dictLabel"
                :value="item.dictValue"
              />
            </el-select>  -->
            <el-input
              v-model="formData.model"
              style="width: 100%"
              placeholder="请输入规格型号"
            />
          </el-form-item>
        </el-col>
        <!-- <el-col :span="8"
          ><el-form-item label="供应商：" prop="supplier">
            <el-input
              v-model="formData.supplier"
              v-no-space
              :maxlength="20"
              placeholder="请输入供应商"
            /> </el-form-item
        ></el-col> -->
        <el-col :span="8">
          <el-form-item label="单位：" prop="unit">
            <el-input
              v-model="formData.unit"
              v-no-space
              placeholder="请输入单位"
              :maxlength="10"
            />
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item
            label="重点物料："
            prop="key"
            style="margin-bottom: 0px"
          >
            <el-radio-group v-model="formData.key">
              <el-radio :value="1" size="large">是</el-radio>
              <el-radio :value="0" size="large">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <div style="margin: 0 0 18px 120px; font-size: 12px; color: #3478f6">
            重点物料，在出入库时，需指定出入库物料表具编号，一旦设置，不可更改
          </div>
        </el-col>
      </el-row>
      <!-- <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item label="单位：" prop="unit">
            <el-input
              v-model="formData.unit"
              v-no-space
              placeholder="请输入单位"
              :maxlength="10"
            />
          </el-form-item>
        </el-col>
      </el-row> -->
      <el-row :gutter="10">
        <el-col>
          <el-form-item label="备注：" prop="remark">
            <el-input
              type="textarea"
              :rows="5"
              v-model="formData.remark"
              :maxlength="200"
              show-word-limit
              placeholder="请输入"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleCancel()">取消</el-button>
        <el-button
          type="primary"
          @click="handleSUbmit()"
          :disabled="buttonLoading"
        >
          保存
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import { reactive, ref } from "vue";
import { DICT_KEY } from "@/constants/dict";
import { queryDictList } from "@/api/dict";
import {
  queryMaterielById,
  insertMateriel,
  updateMateriel,
} from "@/api/materiel";
import { ElMessage } from "element-plus";

// 事件传递
const emits = defineEmits(["afterSave"]);

// 弹窗控制
const visible = ref(false);

// 遮罩
const loading = ref(false);

// 表单ref
const ruleRef = ref(null);

// 弹窗参数
const dialogConfig = ref({
  tree: [],
});

// 品牌list
const brandList = ref([]);

// 信号list
const modelList = ref([]);

// 按钮防抖
const buttonLoading = ref(false);

// 树形选择的props
const defaultProps = reactive({
  label: "node",
  disabled: (data) => {
    return data.parentId == "0";
  },
});

// 表单
const formData = ref({
  name: "",
  number: "",
  categoryId: "",
  brand: "",
  model: "",
  supplier: "",
  remark: "",
  unit: "",
  key: 0,
});

// 表单校验
const rules = reactive({
  name: [{ required: true, message: "请输入物料名称", trigger: "blur" }],
  number: [{ required: true, message: "请输入物料编号", trigger: "blur" }],
  categoryId: [{ required: true, message: "请选择物料类别", trigger: "blur" }],
});

// 弹窗保存
const handleSUbmit = () => {
  buttonLoading.value = true;
  ruleRef.value?.validate((valid) => {
    if (valid) {
      if (dialogConfig.value.type) {
        addMateriel(formData.value);
      } else {
        editMateriel({
          ...formData.value,
          categoryId: formData.value.categoryId,
        });
      }
    } else {
      buttonLoading.value = false;
    }
  });
};

// 点击取消
const handleCancel = () => {
  ruleRef.value?.resetFields();
  visible.value = false;
};

// 获取字典数据
const getDictList = () => {
  queryDictList(DICT_KEY["brand"]).then((res) => {
    brandList.value = res.data || [];
  });
  // 规格型号字典,暂时保留
  queryDictList(DICT_KEY["model"]).then((res) => {
    modelList.value = res.data || [];
  });
};

// 新增
const addMateriel = (req) => {
  insertMateriel(req).then((res) => {
    if (res.code == "2000") {
      ElMessage.success("操作成功");
      emits("afterSave");
      visible.value = false;
    }
  });
  setTimeout(() => {
    buttonLoading.value = false;
  }, 300);
};

// 编辑
const editMateriel = (req) => {
  updateMateriel(req).then((res) => {
    if (res.code == "2000") {
      ElMessage.success("操作成功");
      emits("afterSave");
      visible.value = false;
    }
  });
  setTimeout(() => {
    buttonLoading.value = false;
  }, 300);
};

// 通过id获取数据
const getDataById = (id) => {
  loading.value = true;
  queryMaterielById(id)
    .then((res) => {
      let keys = Object.keys(res.data);
      Object.entries(formData.value).forEach((item) => {
        if (keys.includes(item[0])) {
          formData.value[item[0]] = res.data[item[0]];
        }
      });
      formData.value.brand = formData.value.brand
        ? formData.value.brand * 1
        : null;
      // model以前是字典获取,值需要是数字(字典下拉选择值),所以转换为数字,后期修改为用户自填,不需要转化数字了,暂时保留注释
      // formData.value.model = formData.value.model
      //   ? formData.value.model * 1
      //   : null;

      formData.value.id = res.data.id;
      formData.value.categoryId = formData.value.categoryId.toString();
    })
    .finally(() => {
      loading.value = false;
    });
};

// 弹窗打开
const handleDialogOpen = (config) => {
  dialogConfig.value = { ...config };
  getDictList();
  ruleRef.value?.resetFields();
  if (config.type) {
    formData.value = {
      name: "",
      number: "",
      categoryId: "",
      brand: "",
      model: "",
      supplier: "",
      remark: "",
      unit: "",
      key: 0,
    };
  } else {
    getDataById(config.row.id);
  }
  visible.value = true;
};

// 暴露函数
defineExpose({
  handleDialogOpen,
});
</script>

<style lang="scss" scoped></style>
